(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sasha-footer"] && !Shopify.designMode) return;
  try {
    
const correctNewsletterSuccessScroll = () => {
  const status = document.querySelector('[data-newsletter-success]');

  if (!status) return;

  const newsletter = status.closest('.sasha-newsletter');
  const pageWrapper = document.querySelector('.page-wrapper');
  const cleanUrl = new URL(window.location.href);

  cleanUrl.hash = '';
  cleanUrl.searchParams.delete('customer_posted');
  cleanUrl.searchParams.delete('form_type');
  history.replaceState(null, '', `${cleanUrl.pathname}${cleanUrl.search}`);

  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

      if (newsletter && pageWrapper) {
        const newsletterTop =
          newsletter.getBoundingClientRect().top -
          pageWrapper.getBoundingClientRect().top +
          pageWrapper.scrollTop;

        pageWrapper.scrollTop = Math.max(0, newsletterTop - 24);
      }

  status.focus({ preventScroll: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', correctNewsletterSuccessScroll, { once: true });
} else {
  correctNewsletterSuccessScroll();
}

if (document.readyState === 'complete') {
  correctNewsletterSuccessScroll();
} else {
  window.addEventListener('load', correctNewsletterSuccessScroll, { once: true });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sasha-portrait-product"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.sasha-portrait-product').forEach((section) => {
  const price = section.querySelector('[data-portrait-price]');
  const givingAmount = section.querySelector('[data-giving-amount]');
  const submitButton = section.querySelector('.sasha-portrait-product__submit');
  const selectedVariantId = section.querySelector('[data-portrait-variant-id]');
  const mainImage = section.querySelector('.sasha-portrait-product__main-image');
  const portraitMobileTrack = section.querySelector('[data-portrait-mobile-track]');
  const portraitMobileSlides = [...section.querySelectorAll('[data-portrait-mobile-slide]')];
  const portraitPagination = section.querySelector('[data-portrait-pagination]');
  const portraitThumbs = [...section.querySelectorAll('[data-portrait-thumb]')];
  const portraitDots = [...section.querySelectorAll('[data-portrait-dot]')];
  const portraitGalleryMedia = window.matchMedia('(max-width: 749px)');
  const photoPicker = section.querySelector('[data-photo-picker]');
  const photoSource = section.querySelector('[data-photo-source]');
  const photoTrigger = section.querySelector('[data-photo-trigger]');
  const photoPreviews = section.querySelector('[data-photo-previews]');
  const photoProperties = [...section.querySelectorAll('[data-photo-property]')];
  const photoError = section.querySelector('[data-photo-error]');
  const portraitHelpers = [...section.querySelectorAll('[data-portrait-help]')];
  const directionDescription = section.querySelector('[data-direction-description-output]');
  const directionMockupThumb = section.querySelector('[data-direction-mockup-thumb]');
  const currency = section.dataset.currency || 'EUR';
  const country = section.dataset.country || '';
  const language = section.dataset.locale || document.documentElement.lang || 'en';
  const locale = country && !language.includes('-') ? `${language}-${country}` : language;
  const text = {
    petPortrait: section.dataset.textPetPortrait || 'Pet portrait',
    removePhoto: section.dataset.textRemovePhoto || 'Remove __FILENAME__',
    addMorePhotos: section.dataset.textAddMorePhotos || 'Add more photos',
    yourPhotos: section.dataset.textYourPhotos || 'Your photos',
    onePlaceRemaining: section.dataset.textOnePlaceRemaining || '1 place remaining',
    placesRemaining: section.dataset.textPlacesRemaining || '__COUNT__ places remaining',
    maximumPhotos: section.dataset.textMaximumPhotos || 'Maximum of 3 photos',
    invalidType: section.dataset.textInvalidType || 'Please use JPG, PNG, WebP or HEIC images.',
    fileTooLarge: section.dataset.textFileTooLarge || 'Some photos weren’t added because their combined file size exceeds 18 MB. You can continue your order and email the remaining photos to bysashaliley@gmail.com after placing your order.',
    tooManyPhotos: section.dataset.textTooManyPhotos || 'You can upload up to three photos.',
  };

  const closePortraitHelper = (helper) => {
    if (!helper) return;
    helper.classList.remove('is-open');
    helper.querySelector('[data-portrait-help-trigger]')?.setAttribute('aria-expanded', 'false');
  };

  portraitHelpers.forEach((helper) => {
    const trigger = helper.querySelector('[data-portrait-help-trigger]');
    trigger?.addEventListener('click', (event) => {
      event.stopPropagation();
      const willOpen = !helper.classList.contains('is-open');
      portraitHelpers.forEach((candidate) => closePortraitHelper(candidate));
      helper.classList.toggle('is-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });

  document.addEventListener('click', (event) => {
    portraitHelpers.forEach((helper) => {
      if (!helper.contains(event.target)) closePortraitHelper(helper);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') portraitHelpers.forEach((helper) => closePortraitHelper(helper));
  });

  const formatMoney = (minorUnits) => {
    try {
      const currencyFormatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      });
      const fractionDigits = currencyFormatter.resolvedOptions().maximumFractionDigits;
      const divisor = 10 ** Math.max(2, fractionDigits);
      const value = minorUnits / divisor;
      const hasFraction = Math.abs(value - Math.round(value)) > Number.EPSILON;

      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: hasFraction ? fractionDigits : 0,
        maximumFractionDigits: fractionDigits,
      }).format(value);
    } catch (_error) {
      return `${(minorUnits / 100).toFixed(2)} ${currency}`;
    }
  };

  const sizeInputs = [...section.querySelectorAll('[data-portrait-option="size"]')];
  const frameInputs = [...section.querySelectorAll('[data-portrait-option="frame"]')];
  const frameUnavailableMessage = section.querySelector('[data-portrait-frame-unavailable]');
  const variants = [...section.querySelectorAll('[data-portrait-variant-record]')].map((record) => ({
    id: record.dataset.variantId,
    size: record.dataset.sizeValue || '',
    frame: record.dataset.frameValue || '',
    isFramed: record.dataset.isFramed === 'true',
    available: record.dataset.available === 'true',
    price: record.dataset.variantPrice || '',
    priceMinor: Number(record.dataset.variantPriceMinor || 0),
  }));
  let activeVariant = null;

  const selectedValue = (inputs) => inputs.find((input) => input.checked)?.value || '';
  const findVariant = (size, frame) => variants.find((variant) => (
    variant.size === size && variant.frame === frame
  ));

  const updateGivingAmount = () => {
    if (!givingAmount || !activeVariant) return;
    givingAmount.textContent = formatMoney(Math.round(activeVariant.priceMinor * 0.1));
  };

  const updateOptionAvailability = () => {
    sizeInputs.forEach((input) => {
      input.disabled = !variants.some((variant) => variant.size === input.value && variant.available);
    });

    if (!frameInputs.length) return;
    const size = selectedValue(sizeInputs);
    frameInputs.forEach((input) => {
      const variant = findVariant(size, input.value);
      input.disabled = !variant?.available;
    });

    const framedInput = frameInputs.find((input) => input.dataset.isFramed === 'true');
    if (frameUnavailableMessage) frameUnavailableMessage.hidden = !framedInput?.disabled;
  };

  const updateSubmitButton = (variant) => {
    if (!submitButton) return;
    submitButton.disabled = !variant?.available;
    submitButton.replaceChildren(document.createTextNode(
      variant?.available ? `${section.dataset.orderLabel} — ` : section.dataset.unavailableLabel
    ));
    if (!variant?.available) return;
    const amount = document.createElement('span');
    amount.dataset.portraitButtonPrice = '';
    amount.textContent = variant.price;
    submitButton.append(amount);
  };

  const applyVariant = (variant) => {
    if (!variant) return;
    activeVariant = variant;
    if (selectedVariantId) {
      selectedVariantId.value = variant.id;
      selectedVariantId.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (price) price.textContent = variant.price;
    updateSubmitButton(variant);
    section.dispatchEvent(new CustomEvent('sasha:variant', { detail: variant }));
    updateGivingAmount();
  };

  const resolveVariantSelection = () => {
    const size = selectedValue(sizeInputs);
    let frame = selectedValue(frameInputs);
    let variant = findVariant(size, frame);

    if ((!variant || !variant.available) && frameInputs.length) {
      const unframedInput = frameInputs.find((input) => input.dataset.isFramed !== 'true');
      const unframedVariant = unframedInput ? findVariant(size, unframedInput.value) : null;
      if (unframedInput && unframedVariant?.available) {
        unframedInput.checked = true;
        frame = unframedInput.value;
        variant = unframedVariant;
      }
    }

    updateOptionAvailability();
    applyVariant(variant);
  };

  [...sizeInputs, ...frameInputs].forEach((input) => {
    input.addEventListener('change', resolveVariantSelection);
  });

  const getVisiblePortraitThumbs = () => portraitThumbs.filter((thumb) => (
    !thumb.hidden && Boolean(thumb.dataset.imageSrc)
  ));

  const getVisiblePortraitSlides = () => portraitMobileSlides.filter((slide) => !slide.hidden);

  const preloadPortraitNeighbors = (key) => {
    if (!portraitGalleryMedia.matches) return;
    const visibleSlides = getVisiblePortraitSlides();
    const activeIndex = visibleSlides.findIndex((slide) => slide.dataset.portraitKey === key);
    [activeIndex, activeIndex - 1, activeIndex + 1].forEach((index) => {
      const image = visibleSlides[index]?.querySelector('img');
      if (!image) return;
      image.loading = 'eager';
      image.fetchPriority = 'low';
      image.decode?.().catch(() => {});
    });
  };

  const setActivePortraitKey = (key) => {
    if (!key) return;
    portraitMobileSlides.forEach((slide) => {
      slide.classList.toggle('is-active', slide.dataset.portraitKey === key);
    });
    portraitThumbs.forEach((candidate) => {
      const isActive = candidate.dataset.portraitKey === key;
      candidate.classList.toggle('is-active', isActive);
      candidate.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    portraitDots.forEach((dot) => {
      const isActive = dot.dataset.portraitKey === key;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
    preloadPortraitNeighbors(key);
  };

  const scrollToPortraitKey = (key, behavior = 'smooth') => {
    if (!portraitMobileTrack) return;
    const visibleSlides = getVisiblePortraitSlides();
    const index = visibleSlides.findIndex((slide) => slide.dataset.portraitKey === key);
    if (index < 0) return;
    portraitMobileTrack.scrollTo({
      left: index * portraitMobileTrack.clientWidth,
      behavior,
    });
  };

  const updatePortraitMobileSlide = (key, source, alt) => {
    const slide = portraitMobileSlides.find((candidate) => candidate.dataset.portraitKey === key);
    if (!slide) return;
    slide.hidden = !source;
    if (!source) return;
    let image = slide.querySelector('img');
    if (!image) {
      image = document.createElement('img');
      image.className = 'sasha-portrait-product__mobile-image';
      image.loading = 'lazy';
      slide.replaceChildren(image);
    }
    image.src = source;
    image.removeAttribute('srcset');
    image.alt = alt || text.petPortrait;
  };

  const syncPortraitPagination = () => {
    const visibleThumbs = getVisiblePortraitThumbs();
    if (portraitPagination) portraitPagination.hidden = visibleThumbs.length < 2;
    portraitDots.forEach((dot) => {
      const matchingThumb = portraitThumbs.find((thumb) => thumb.dataset.portraitKey === dot.dataset.portraitKey);
      dot.hidden = !matchingThumb || matchingThumb.hidden || !matchingThumb.dataset.imageSrc;
    });
    portraitMobileSlides.forEach((slide) => {
      const matchingThumb = portraitThumbs.find((thumb) => thumb.dataset.portraitKey === slide.dataset.portraitKey);
      slide.hidden = !matchingThumb || matchingThumb.hidden || !matchingThumb.dataset.imageSrc;
    });
  };

  const showPortraitImage = (thumb) => {
    if (!thumb?.dataset.imageSrc) return;
    const key = thumb.dataset.portraitKey;
    if (portraitGalleryMedia.matches) {
      scrollToPortraitKey(key);
    } else if (mainImage) {
      mainImage.src = thumb.dataset.imageSrc;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.alt = thumb.dataset.imageAlt || mainImage.alt || text.petPortrait;
    }
    setActivePortraitKey(key);
  };

  section.querySelectorAll('input[name="properties[Direction]"]').forEach((input) => {
    input.addEventListener('change', () => {
      if (!input.checked) return;
      if (directionDescription) {
        directionDescription.textContent = input.dataset.directionDescription || '';
      }
      if (directionMockupThumb) {
        const mockupSource = input.dataset.directionMockup || '';
        directionMockupThumb.hidden = !mockupSource;
        if (mockupSource) {
          directionMockupThumb.dataset.imageSrc = mockupSource;
          directionMockupThumb.dataset.imageAlt = input.dataset.directionMockupAlt || `${input.value} mockup`;
          let mockupImage = directionMockupThumb.querySelector('img');
          if (!mockupImage) {
            mockupImage = document.createElement('img');
            directionMockupThumb.replaceChildren(mockupImage);
          }
          mockupImage.src = mockupSource;
          mockupImage.removeAttribute('srcset');
          mockupImage.alt = directionMockupThumb.dataset.imageAlt;
          updatePortraitMobileSlide('mockup', mockupSource, directionMockupThumb.dataset.imageAlt);
        } else {
          delete directionMockupThumb.dataset.imageSrc;
          delete directionMockupThumb.dataset.imageAlt;
          updatePortraitMobileSlide('mockup', '', '');
        }
      }
      if (!input.dataset.directionImage) return;
      const primaryThumb = portraitThumbs[0];
      if (primaryThumb) {
        primaryThumb.dataset.imageSrc = input.dataset.directionImage;
        primaryThumb.dataset.imageAlt = input.dataset.directionAlt || input.value;
        const primaryThumbImage = primaryThumb.querySelector('img');
        if (primaryThumbImage) {
          primaryThumbImage.src = input.dataset.directionImage;
          primaryThumbImage.removeAttribute('srcset');
          primaryThumbImage.alt = input.dataset.directionAlt || input.value;
        }
        updatePortraitMobileSlide('primary', input.dataset.directionImage, input.dataset.directionAlt || input.value);
      }
      syncPortraitPagination();
      showPortraitImage(primaryThumb);
    });
  });

  portraitThumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => showPortraitImage(thumb));
  });

  portraitDots.forEach((dot) => {
    dot.addEventListener('click', () => {
      showPortraitImage(portraitThumbs.find((thumb) => thumb.dataset.portraitKey === dot.dataset.portraitKey));
    });
  });

  let portraitScrollFrame = null;
  portraitMobileTrack?.addEventListener('scroll', () => {
    if (portraitScrollFrame) return;
    portraitScrollFrame = requestAnimationFrame(() => {
      portraitScrollFrame = null;
      if (!portraitMobileTrack.clientWidth) return;
      const visibleSlides = getVisiblePortraitSlides();
      const index = Math.round(portraitMobileTrack.scrollLeft / portraitMobileTrack.clientWidth);
      const activeSlide = visibleSlides[Math.min(Math.max(index, 0), visibleSlides.length - 1)];
      setActivePortraitKey(activeSlide?.dataset.portraitKey);
    });
  }, { passive: true });

  syncPortraitPagination();
  const initialPortraitKey = portraitThumbs.find((thumb) => thumb.classList.contains('is-active'))?.dataset.portraitKey || 'primary';
  setActivePortraitKey(initialPortraitKey);
  requestAnimationFrame(() => scrollToPortraitKey(initialPortraitKey, 'auto'));

  if (photoPicker && photoSource && photoTrigger && photoPreviews && photoProperties.length) {
    let selectedPhotos = [];
    const maxTotalPhotoSize = 18 * 1024 * 1024;
    const acceptedPhotoTypes = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/heic']);
    const acceptedPhotoExtensions = new Set(['jpg', 'jpeg', 'png', 'webp', 'heic']);

    const setPhotoError = (message = '') => {
      if (!photoError) return;
      photoError.textContent = message;
      photoError.hidden = !message;
      photoPicker.classList.toggle('has-error', Boolean(message));
    };

    const getPhotoExtension = (file) => file.name.split('.').pop()?.toLowerCase() || '';

    const isAcceptedPhoto = (file) => (
      acceptedPhotoTypes.has(file.type.toLowerCase())
      || acceptedPhotoExtensions.has(getPhotoExtension(file))
    );

    const isHeicPhoto = (file) => (
      file.type === 'image/heic'
      || getPhotoExtension(file) === 'heic'
    );

    const assignPhotosToProperties = () => {
      photoProperties.forEach((input, index) => {
        const transfer = new DataTransfer();
        if (selectedPhotos[index]) transfer.items.add(selectedPhotos[index]);
        input.files = transfer.files;
      });
    };

    const renderPhotoPreviews = () => {
      photoPreviews.replaceChildren();

      selectedPhotos.forEach((file, index) => {
        const preview = document.createElement('div');
        preview.className = 'sasha-portrait-product__photo-preview';

        if (isHeicPhoto(file)) {
          const filePreview = document.createElement('div');
          filePreview.className = 'sasha-portrait-product__photo-preview-file';
          filePreview.textContent = 'HEIC';
          preview.append(filePreview);
        } else {
          const image = document.createElement('img');
          image.src = URL.createObjectURL(file);
          image.alt = '';
          image.addEventListener('load', () => URL.revokeObjectURL(image.src), { once: true });
          preview.append(image);
        }

        const name = document.createElement('span');
        name.textContent = file.name;

        const remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'sasha-portrait-product__photo-remove';
        remove.setAttribute('aria-label', text.removePhoto.replace('__FILENAME__', file.name));
        remove.textContent = '×';
        remove.addEventListener('click', () => {
          selectedPhotos.splice(index, 1);
          assignPhotosToProperties();
          renderPhotoPreviews();
          setPhotoError('');
        });

        preview.append(name, remove);
        photoPreviews.append(preview);
      });

      const remaining = 3 - selectedPhotos.length;
      const photoTriggerText = photoTrigger.querySelector('.sasha-portrait-product__photo-trigger-label > span');
      const remainingText = remaining
        ? (remaining === 1
          ? text.onePlaceRemaining
          : text.placesRemaining.replace('__COUNT__', remaining))
        : text.maximumPhotos;
      if (photoTriggerText) {
        photoTriggerText.textContent = selectedPhotos.length ? text.addMorePhotos : text.yourPhotos;
      }
      photoTrigger.setAttribute('aria-label', `${photoTriggerText?.textContent || text.yourPhotos}. ${remainingText}`);
      photoTrigger.disabled = remaining === 0;
    };

    const addPhotos = (files) => {
      const previousPhotoCount = selectedPhotos.length;
      const incomingPhotos = [...files];
      const messages = [];
      let totalPhotoSize = selectedPhotos.reduce((total, file) => total + file.size, 0);
      let remainingPlaces = 3 - selectedPhotos.length;
      let hasInvalidType = false;
      let hasOversizedTotal = false;
      let hasTooManyPhotos = false;

      incomingPhotos.forEach((file) => {
        if (!isAcceptedPhoto(file)) {
          hasInvalidType = true;
          return;
        }
        if (remainingPlaces === 0) {
          hasTooManyPhotos = true;
          return;
        }
        if (totalPhotoSize + file.size > maxTotalPhotoSize) {
          hasOversizedTotal = true;
          return;
        }

        selectedPhotos.push(file);
        totalPhotoSize += file.size;
        remainingPlaces -= 1;
      });

      if (hasInvalidType) messages.push(text.invalidType);
      if (hasOversizedTotal) messages.push(text.fileTooLarge);
      if (hasTooManyPhotos) messages.push(text.tooManyPhotos);

      assignPhotosToProperties();
      renderPhotoPreviews();
      setPhotoError(messages.join(' '));
      section.dispatchEvent(new CustomEvent('sasha:analytics-photos', {
        bubbles: true,
        detail: {
          added: selectedPhotos.length - previousPhotoCount,
          errors: [
            hasInvalidType ? 'photo_type' : null,
            hasOversizedTotal ? 'photo_total_size' : null,
            hasTooManyPhotos ? 'photo_count' : null,
          ].filter(Boolean),
        },
      }));
    };

    photoTrigger.addEventListener('click', () => photoSource.click());
    photoSource.addEventListener('change', () => {
      addPhotos(photoSource.files);
      photoSource.value = '';
    });

    ['dragenter', 'dragover'].forEach((eventName) => {
      photoPicker.addEventListener(eventName, (event) => {
        event.preventDefault();
        photoPicker.classList.add('is-dragging');
      });
    });

    ['dragleave', 'drop'].forEach((eventName) => {
      photoPicker.addEventListener(eventName, (event) => {
        event.preventDefault();
        photoPicker.classList.remove('is-dragging');
      });
    });

    photoPicker.addEventListener('drop', (event) => addPhotos(event.dataTransfer.files));
  }

  resolveVariantSelection();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sasha-print-grid"] && !Shopify.designMode) return;
  try {
    
class SashaPrintGrid extends HTMLElement {
  setupQuickAdd(root = this) {
      root.querySelectorAll('[data-sasha-quick-add-open]:not([data-quick-ready])').forEach((button) => {
        button.dataset.quickReady = 'true';
        button.addEventListener('click', () => {
          const dialog = this.querySelector(`#${CSS.escape(button.dataset.sashaQuickAddOpen)}`);
          if (dialog instanceof HTMLDialogElement) dialog.showModal();
        });
      });
      root.querySelectorAll('[data-sasha-quick-add-close]:not([data-quick-ready])').forEach((button) => {
        button.dataset.quickReady = 'true';
        button.addEventListener('click', () => button.closest('dialog')?.close());
      });
      root.querySelectorAll('.sasha-print-grid__quick-dialog:not([data-quick-ready])').forEach((dialog) => {
        dialog.dataset.quickReady = 'true';
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        const variantIdInput = dialog.querySelector('[data-sasha-quick-variant-id]');
        if (!variantIdInput) {
          dialog.querySelectorAll('input[type="radio"][data-price]').forEach((input) => {
            input.addEventListener('change', () => {
              if (!input.checked) return;
              const price = input.dataset.price;
              const headingPrice = dialog.querySelector('[data-sasha-quick-price]');
              const submitPrice = dialog.querySelector('[data-sasha-quick-submit-price]');
              if (headingPrice) headingPrice.textContent = price;
              if (submitPrice) submitPrice.textContent = price;
            });
          });
          return;
        }

        const sizeInputs = [...dialog.querySelectorAll('[data-sasha-quick-size]')];
        const frameInputs = [...dialog.querySelectorAll('[data-sasha-quick-frame]')];
        const headingPrice = dialog.querySelector('[data-sasha-quick-price]');
        const submitPrice = dialog.querySelector('[data-sasha-quick-submit-price]');
        const submitButton = dialog.querySelector('.sasha-print-grid__quick-submit');
        const quickImage = dialog.querySelector('[data-sasha-quick-image]');
        const defaultImage = quickImage ? {
          src: quickImage.src,
          srcset: quickImage.getAttribute('srcset') || '',
          sizes: quickImage.getAttribute('sizes') || '',
          alt: quickImage.alt || '',
        } : null;
        const variants = [...dialog.querySelectorAll('[data-sasha-quick-variant-record]')].map((record) => ({
          id: record.dataset.variantId,
          size: record.dataset.sizeValue || '',
          frame: record.dataset.frameValue || '',
          isFramed: record.dataset.isFramed === 'true',
          available: record.dataset.available === 'true',
          price: record.dataset.price || '',
          imageSrc: record.dataset.imageSrc || '',
          imageAlt: record.dataset.imageAlt || '',
        }));

        const selectedValue = (inputs) => inputs.find((input) => input.checked)?.value || '';
        const findVariant = (size, frame) => variants.find((variant) => (
          variant.size === size && variant.frame === frame
        ));
        const restoreQuickImage = () => {
          if (!quickImage || !defaultImage) return;
          quickImage.src = defaultImage.src;
          if (defaultImage.srcset) quickImage.setAttribute('srcset', defaultImage.srcset);
          else quickImage.removeAttribute('srcset');
          if (defaultImage.sizes) quickImage.setAttribute('sizes', defaultImage.sizes);
          else quickImage.removeAttribute('sizes');
          quickImage.alt = defaultImage.alt;
          quickImage.classList.remove('is-frame-preview');
        };
        const updateQuickImage = (variant) => {
          if (!variant?.isFramed || !variant.imageSrc) {
            restoreQuickImage();
            return;
          }
          if (!quickImage) return;
          quickImage.src = variant.imageSrc;
          quickImage.removeAttribute('srcset');
          quickImage.removeAttribute('sizes');
          quickImage.alt = variant.imageAlt;
          quickImage.classList.add('is-frame-preview');
        };
        const updateAvailability = () => {
          sizeInputs.forEach((input) => {
            input.disabled = !variants.some((variant) => variant.size === input.value && variant.available);
          });
          const size = selectedValue(sizeInputs);
          frameInputs.forEach((input) => {
            input.disabled = !findVariant(size, input.value)?.available;
          });
        };
        const applyVariant = (variant) => {
          if (!variant) {
            if (submitButton) submitButton.disabled = true;
            return;
          }
          variantIdInput.value = variant.id;
          if (headingPrice) headingPrice.textContent = variant.price;
          if (submitPrice) submitPrice.textContent = variant.price;
          if (submitButton) submitButton.disabled = !variant.available;
          updateQuickImage(variant);
        };
        const resolveSelection = () => {
          const size = selectedValue(sizeInputs);
          let frame = selectedValue(frameInputs);
          let variant = findVariant(size, frame);

          if (!variant?.available) {
            const unframedInput = frameInputs.find((input) => input.dataset.isFramed !== 'true');
            const unframedVariant = unframedInput ? findVariant(size, unframedInput.value) : null;
            if (unframedInput && unframedVariant?.available) {
              unframedInput.checked = true;
              frame = unframedInput.value;
              variant = unframedVariant;
            }
          }

          updateAvailability();
          applyVariant(variant);
        };

        [...sizeInputs, ...frameInputs].forEach((input) => {
          input.addEventListener('change', resolveSelection);
        });
        resolveSelection();
      });
  }

  connectedCallback() {
    this.setupQuickAdd();
    this.setupFeaturedRail();
    this.setupMobileViews();
    this.dispatchEvent(new CustomEvent('sasha:analytics-catalog', { bubbles: true }));
    if (!this.hasAttribute('data-filtering') || this.dataset.initialized) return;
    this.dataset.initialized = 'true';
    this.items = Array.from(this.querySelectorAll('[data-print-item]'));
    const requestedFilter = new URLSearchParams(window.location.search).get('filter');
    const pathFilter = window.location.pathname.includes('/collections/cat-art-prints')
      ? 'cat'
      : window.location.pathname.includes('/collections/dog-art-prints')
        ? 'dog'
        : 'all';
    const validFilters = ['all', 'best', 'cat', 'dog'];
    this.filter = validFilters.includes(requestedFilter) ? requestedFilter : (this.dataset.catalogFilter || pathFilter);
    this.sort = 'newest';
    this.updateActiveFilter();
    if (this.hasAttribute('data-manual-catalog') && this.filter !== this.dataset.catalogFilter) {
      this.navigateTo(window.location.href, false);
    }
    this.addEventListener('click', (event) => {
      const link = event.target.closest('[data-print-load-more]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.loadMore(link, event.detail === 0);
    });
    this.querySelectorAll('[data-print-nav]').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (
          event.defaultPrevented
          || event.button !== 0
          || event.metaKey
          || event.ctrlKey
          || event.shiftKey
          || event.altKey
        ) return;

        event.preventDefault();
        this.navigateTo(link.href);
      });
    });
    this.renderItems();

    if (!window.sashaPrintGridPopstateBound) {
      window.sashaPrintGridPopstateBound = true;
      window.addEventListener('popstate', () => {
        const catalog = document.querySelector('sasha-print-grid[data-print-catalog]');
        if (catalog instanceof SashaPrintGrid) catalog.navigateTo(window.location.href, false);
      });
    }
  }

  updateActiveFilter() {
    this.querySelectorAll('[data-print-filter]').forEach((link) => {
      if (link.dataset.printFilter === this.filter) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  disconnectedCallback() {
    this.mobileViewAbort?.abort();
    this.mobileViewAbort = null;
    document.dispatchEvent(new CustomEvent('sasha:analytics-catalog'));
  }

  setupMobileViews() {
    if (!this.hasAttribute('data-mobile-catalog-views') || this.mobileViewAbort) return;
    this.mobileViewAbort = new AbortController();
    const { signal } = this.mobileViewAbort;
    const storageKey = 'sasha-print-catalog-view-v1';
    let saved = window.sashaPrintCatalogView;
    if (!saved) {
      try {
        saved = JSON.parse(sessionStorage.getItem(storageKey));
      } catch {
        saved = null;
      }
    }
    const view = {
      columns: saved?.columns === '1' ? '1' : '2',
      image: saved?.image === 'lifestyle' ? 'lifestyle' : 'artwork',
    };
    window.sashaPrintCatalogView = view;
    const mobile = window.matchMedia('(max-width: 749px)');
    const applyView = () => {
      this.dataset.mobileColumns = view.columns;
      this.dataset.imageView = view.image;
      this.querySelectorAll('[data-mobile-columns-button]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.mobileColumnsButton === view.columns));
      });
      this.querySelectorAll('[data-image-view-button]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.imageViewButton === view.image));
      });
      this.querySelectorAll('[data-catalog-preview-source]').forEach((source) => {
        const srcset = view.image === 'lifestyle' ? source.dataset.lifestyleSrcset : source.dataset.artworkSrcset;
        if (source.srcset !== srcset) source.srcset = srcset;
        source.sizes = view.columns === '1' ? 'calc(100vw - 32px)' : 'calc((100vw - 44px) / 2)';
        const image = source.parentElement.querySelector('img');
        if (image) image.alt = mobile.matches
          ? (view.image === 'lifestyle' ? source.dataset.lifestyleAlt : source.dataset.artworkAlt)
          : source.dataset.desktopAlt;
      });
    };
    const saveView = () => {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(view));
      } catch {}
      applyView();
    };
    this.querySelectorAll('[data-mobile-columns-button]').forEach((button) => {
      button.addEventListener('click', () => {
        view.columns = button.dataset.mobileColumnsButton === '1' ? '1' : '2';
        saveView();
      }, { signal });
    });
    this.querySelectorAll('[data-image-view-button]').forEach((button) => {
      button.addEventListener('click', () => {
        view.image = button.dataset.imageViewButton === 'lifestyle' ? 'lifestyle' : 'artwork';
        saveView();
      }, { signal });
    });
    this.applyMobileView = applyView;
    mobile.addEventListener('change', applyView, { signal });
    applyView();
    this.querySelector('[data-mobile-view-controls]')?.removeAttribute('hidden');
  }

  async navigateTo(url, pushState = true) {
    if (this.dataset.navigationPending) return;
    this.dataset.navigationPending = 'true';
    this.classList.add('is-loading');

    try {
      let fetchUrl = new URL(url, window.location.href);
      let historyUrl = fetchUrl;
      if (this.hasAttribute('data-manual-catalog')) {
        const requested = fetchUrl.searchParams.get('filter');
        const tag = fetchUrl.pathname.split('/').filter(Boolean).pop();
        const filter = { 'prints-cat': 'cat', 'prints-dog': 'dog', 'prints-best-seller': 'best' }[tag]
          || (['cat', 'dog', 'best'].includes(requested) ? requested : 'all');
        const suffix = { cat: '/prints-cat', dog: '/prints-dog', best: '/prints-best-seller', all: '' }[filter];
        fetchUrl = new URL(this.dataset.catalogUrl + suffix, window.location.origin);
        historyUrl = new URL(this.dataset.catalogPageUrl, window.location.origin);
        if (filter !== 'all') historyUrl.searchParams.set('filter', filter);
      }
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) fetchUrl.searchParams.set('preview_theme_id', preview);
      const response = await fetch(fetchUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        credentials: 'same-origin',
      });
      if (!response.ok) throw new Error(`Unable to load ${url}`);

      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextCatalog = nextDocument.querySelector('sasha-print-grid[data-print-catalog]');
      if (!nextCatalog) throw new Error('Print catalogue not found');

      document.title = nextDocument.title;
      const nextCanonical = nextDocument.querySelector('link[rel="canonical"]')?.href;
      const currentCanonical = document.querySelector('link[rel="canonical"]');
      if (nextCanonical && currentCanonical) currentCanonical.href = nextCatalog.hasAttribute('data-manual-catalog')
        ? new URL(nextCatalog.dataset.catalogPageUrl, window.location.origin).href
        : nextCanonical;
      if (pushState) history.pushState({ sashaPrintCatalog: true }, '', historyUrl);

      this.replaceWith(nextCatalog);
      window.scrollTo({ top: nextCatalog.offsetTop, behavior: 'smooth' });
    } catch (error) {
      window.location.assign(url);
    } finally {
      this.dataset.navigationPending = '';
      this.classList.remove('is-loading');
    }
  }

  async loadMore(link, keyboardNavigation = false) {
    if (this.dataset.paginationPending) return;
    this.dataset.paginationPending = 'true';
    link.setAttribute('aria-disabled', 'true');
    this.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(link.href);
      const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Unable to load prints');
      const nextDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextCatalog = nextDocument.querySelector('sasha-print-grid[data-manual-catalog]');
      if (!nextCatalog || nextCatalog.dataset.catalogFilter !== this.dataset.catalogFilter) throw new Error('Print selection mismatch');
      const fragment = document.createDocumentFragment();
      const existing = new Set(this.items.map((item) => item.dataset.analyticsProductId));
      let firstAdded;
      nextCatalog.querySelectorAll('[data-print-item]').forEach((item) => {
        if (existing.has(item.dataset.analyticsProductId)) return;
        existing.add(item.dataset.analyticsProductId);
        if (!firstAdded) firstAdded = item;
        fragment.append(item);
      });
      this.setupQuickAdd(fragment);
      this.querySelector('[data-print-items]').append(fragment);
      this.items = [...this.querySelectorAll('[data-print-item]')];
      const next = nextCatalog.querySelector('[data-print-load-more]');
      if (next) link.href = next.href;
      else this.querySelector('[data-print-pagination]').hidden = true;
      this.applyMobileView?.();
      this.renderItems();
      if (firstAdded && keyboardNavigation) {
        const target = firstAdded.querySelector('a');
        target?.focus({ preventScroll: true });
      }
    } catch {
      window.location.assign(link.href);
    } finally {
      this.dataset.paginationPending = '';
      link.removeAttribute('aria-disabled');
      this.removeAttribute('aria-busy');
    }
  }

  setupFeaturedRail() {
    const rail = this.querySelector('[data-featured-rail]');
    if (!rail || this.dataset.featuredRailInitialized) return;

    const previousButton = this.querySelector('[data-featured-scroll-previous]');
    const nextButton = this.querySelector('[data-featured-scroll-next]');
    if (!previousButton || !nextButton) return;

    this.dataset.featuredRailInitialized = 'true';
    let frame;

    const updateButtons = () => {
      const maximumScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      previousButton.disabled = rail.scrollLeft <= 2;
      nextButton.disabled = maximumScroll <= 2 || rail.scrollLeft >= maximumScroll - 2;
      this.dataset.featuredRailReady = 'true';
    };

    const requestUpdate = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateButtons);
    };

    previousButton.addEventListener('click', () => {
      rail.scrollBy({ left: -rail.clientWidth, behavior: 'smooth' });
    });
    nextButton.addEventListener('click', () => {
      rail.scrollBy({ left: rail.clientWidth, behavior: 'smooth' });
    });
    rail.addEventListener('scroll', requestUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(requestUpdate).observe(rail);
    } else {
      window.addEventListener('resize', requestUpdate, { passive: true });
    }

    requestUpdate();
  }

  renderItems() {
    const visible = this.items.filter((item) => {
      if (this.hasAttribute('data-manual-catalog') || this.filter === 'all') return true;
      if (this.filter === 'best') return item.dataset.bestseller === 'true';
      return item.dataset.category === this.filter;
    });
    const sorted = this.hasAttribute('data-manual-catalog') ? visible : [...visible].sort((a, b) => {
      if (this.sort === 'title') return a.dataset.title.localeCompare(b.dataset.title);
      const direction = this.sort === 'oldest' ? 1 : -1;
      return a.dataset.release.localeCompare(b.dataset.release) * direction;
    });
    this.items.forEach((item) => { item.hidden = !visible.includes(item); });
    sorted.forEach((item) => this.querySelector('[data-print-items]').append(item));
    const count = this.querySelector('[data-visible-count]');
    if (count) count.textContent = this.hasAttribute('data-manual-catalog') ? this.dataset.catalogCount : String(visible.length);
    this.dataset.analyticsFilter = this.filter;
    this.dispatchEvent(new CustomEvent('sasha:analytics-catalog', { bubbles: true }));
  }
}

if (!customElements.get('sasha-print-grid')) {
  customElements.define('sasha-print-grid', SashaPrintGrid);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sasha-product-recommendations"] && !Shopify.designMode) return;
  try {
    
class SashaProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const recommendations = documentFragment.querySelector('sasha-product-recommendations');

        if (recommendations?.innerHTML.trim()) {
          this.innerHTML = recommendations.innerHTML;
          this.dispatchEvent(new CustomEvent('sasha:analytics-catalog', { bubbles: true }));
        }
      })
      .catch(() => {});
  }

  disconnectedCallback() {
    document.dispatchEvent(new CustomEvent('sasha:analytics-catalog'));
  }
}

if (!customElements.get('sasha-product-recommendations')) {
  customElements.define('sasha-product-recommendations', SashaProductRecommendations);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sasha-product"] && !Shopify.designMode) return;
  try {
    
class SashaProduct extends HTMLElement {
  connectedCallback() {
    if (this.abortController) return;
    this.abortController = new AbortController();
    this.dataset.initialized = 'true';
    const listen = (target, type, callback, options = {}) => target?.addEventListener(type, callback, { ...options, signal: this.abortController.signal });

    const mainImage = this.querySelector('.sasha-product__image');
    const mainStage = this.querySelector('.sasha-product__stage');
    const defaultPaperContext = mainStage?.classList.contains('is-paper-context');
    const mobileTrack = this.querySelector('[data-product-mobile-track]');
    const mobileSlides = [...this.querySelectorAll('[data-product-mobile-slide]')];
    const productThumbs = [...this.querySelectorAll('[data-product-thumb]')];
    const productDots = [...this.querySelectorAll('[data-product-dot]')];
    const mobileGalleryMedia = window.matchMedia('(max-width: 749px)');
    const firstMobileImage = mobileSlides[0]?.querySelector('img');
    const defaultMainImage = mainImage ? {
      src: mainImage.src,
      srcset: mainImage.getAttribute('srcset') || '',
      sizes: mainImage.getAttribute('sizes') || '',
      alt: mainImage.alt || '',
      squareLifestyle: mainImage.classList.contains('is-square-lifestyle'),
    } : null;
    const defaultMobileImage = firstMobileImage ? {
      src: firstMobileImage.src,
      srcset: firstMobileImage.getAttribute('srcset') || '',
      sizes: firstMobileImage.getAttribute('sizes') || '',
      alt: firstMobileImage.alt || '',
      squareLifestyle: firstMobileImage.classList.contains('is-square-lifestyle'),
    } : null;

    const preloadProductImage = (index) => {
      if (!mobileGalleryMedia.matches) return;
      const image = mobileSlides[index]?.querySelector('img');
      if (!image) return;
      image.loading = 'eager';
      image.fetchPriority = index === 0 ? 'high' : 'low';
      image.decode?.().catch(() => {});
    };

    const setActiveProductIndex = (index) => {
      if (index < 0 || index >= mobileSlides.length) return;
      mobileSlides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });
      productThumbs.forEach((thumb) => {
        const isActive = Number(thumb.dataset.galleryIndex) === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
      productDots.forEach((dot) => {
        const isActive = Number(dot.dataset.galleryIndex) === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      preloadProductImage(index);
      preloadProductImage(index - 1);
      preloadProductImage(index + 1);
    };

    const showProductImage = (button) => {
      if (!mainImage || !button?.dataset.imageSrc) return;
      mainImage.src = button.dataset.imageSrc;
      mainImage.removeAttribute('srcset');
      mainImage.alt = button.dataset.imageAlt || '';
      mainImage.classList.remove('is-frame-preview');
      mainStage?.classList.toggle('is-paper-context', button.hasAttribute('data-paper-context'));
      mainImage.classList.toggle('is-square-lifestyle', button.hasAttribute('data-square-lifestyle'));
      setActiveProductIndex(Number(button.dataset.galleryIndex));
    };

    const scrollToProductImage = (index, behavior = 'smooth') => {
      if (!mobileTrack || !mobileSlides[index]) return;
      mobileTrack.scrollTo({
        left: index * mobileTrack.clientWidth,
        behavior,
      });
    };

    productThumbs.forEach((button) => {
      listen(button, 'click', () => {
        const index = Number(button.dataset.galleryIndex);
        if (mobileGalleryMedia.matches) {
          scrollToProductImage(index);
        } else {
          showProductImage(button);
        }
      });
    });

    productDots.forEach((dot) => {
      listen(dot, 'click', () => {
        const index = Number(dot.dataset.galleryIndex);
        if (mobileGalleryMedia.matches) {
          scrollToProductImage(index);
        } else {
          showProductImage(productThumbs[index]);
        }
      });
    });

    this.productScrollFrame = null;
    listen(mobileTrack, 'scroll', () => {
      if (this.productScrollFrame) return;
      this.productScrollFrame = requestAnimationFrame(() => {
        this.productScrollFrame = null;
        if (!mobileTrack.clientWidth) return;
        const index = Math.round(mobileTrack.scrollLeft / mobileTrack.clientWidth);
        setActiveProductIndex(Math.min(Math.max(index, 0), mobileSlides.length - 1));
      });
    }, { passive: true });

    const initialProductIndex = Math.max(0, mobileSlides.findIndex((slide) => slide.classList.contains('is-active')));
    setActiveProductIndex(initialProductIndex);
    this.initialFrame = requestAnimationFrame(() => scrollToProductImage(initialProductIndex, 'auto'));

    const price = this.querySelector('[data-product-price]');
    const quantity = this.querySelector('input[name="quantity"]');
    const selectedVariantId = this.querySelector('[data-selected-variant-id]');
    const givingAmount = this.querySelector('[data-giving-amount]');
    const productForm = this.querySelector('.sasha-product__form');
    const primaryAddButton = this.querySelector('.sasha-product__add');
    let primaryAddPrice = this.querySelector('[data-add-price]');
    const stickyCart = this.querySelector('[data-sticky-cart]');
    const stickyVariant = this.querySelector('[data-sticky-variant]');
    const stickyPrice = this.querySelector('[data-sticky-price]');
    const stickyAddButton = this.querySelector('[data-sticky-add]');
    const stickyImage = this.querySelector('.sasha-product__sticky-cart-image');
    const defaultStickyImage = stickyImage ? {
      src: stickyImage.src,
      srcset: stickyImage.getAttribute('srcset') || '',
      alt: stickyImage.alt || '',
    } : null;
    const sizeInputs = [...this.querySelectorAll('[data-product-option="size"]')];
    const frameInputs = [...this.querySelectorAll('[data-product-option="frame"]')];
    const frameUnavailableMessage = this.querySelector('[data-frame-unavailable-message]');
    const variants = [...this.querySelectorAll('[data-variant-record]')].map((record) => ({
      element: record,
      id: record.dataset.variantId,
      size: record.dataset.sizeValue || '',
      frame: record.dataset.frameValue || '',
      isFramed: record.dataset.isFramed === 'true',
      available: record.dataset.available === 'true',
      price: record.dataset.variantPrice || '',
      priceMinor: Number(record.dataset.variantPriceMinor || 0),
      display: record.dataset.variantDisplay || '',
      imageSrc: record.dataset.imageSrc || '',
      imageAlt: record.dataset.imageAlt || '',
    }));
    const currency = this.dataset.currency || 'EUR';
    const country = this.dataset.country || '';
    const language = this.dataset.locale || document.documentElement.lang || 'en';
    const locale = country && !language.includes('-') ? `${language}-${country}` : language;

    const formatMoney = (minorUnits) => {
      try {
        const currencyFormatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
        });
        const fractionDigits = currencyFormatter.resolvedOptions().maximumFractionDigits;
        const divisor = 10 ** Math.max(2, fractionDigits);
        const value = minorUnits / divisor;
        const hasFraction = Math.abs(value - Math.round(value)) > Number.EPSILON;

        return new Intl.NumberFormat(locale, {
          style: 'currency',
          currency,
          minimumFractionDigits: hasFraction ? fractionDigits : 0,
          maximumFractionDigits: fractionDigits,
        }).format(value);
      } catch (_error) {
        return `${(minorUnits / 100).toFixed(2)} ${currency}`;
      }
    };

    let activeVariant = null;

    const updateGivingAmount = () => {
      if (!activeVariant || !givingAmount) return;

      const unitPrice = activeVariant.priceMinor;
      const selectedQuantity = Math.max(1, Math.floor(Number(quantity?.value) || 1));
      givingAmount.textContent = formatMoney(Math.round(unitPrice * selectedQuantity * 0.1));
    };

    const restoreImage = (image, defaults) => {
      if (!image || !defaults) return;
      image.src = defaults.src;
      if (defaults.srcset) image.setAttribute('srcset', defaults.srcset);
      else image.removeAttribute('srcset');
      if (defaults.sizes) image.setAttribute('sizes', defaults.sizes);
      else image.removeAttribute('sizes');
      image.alt = defaults.alt;
      image.classList.remove('is-frame-preview');
      if (image === mainImage) mainStage?.classList.toggle('is-paper-context', Boolean(defaultPaperContext));
      image.classList.toggle('is-square-lifestyle', Boolean(defaults.squareLifestyle));
    };

    const showFramePreview = (variant) => {
      const shouldShowFrame = variant?.isFramed && variant.imageSrc;
      if (!shouldShowFrame) {
        restoreImage(mainImage, defaultMainImage);
        restoreImage(firstMobileImage, defaultMobileImage);
        restoreImage(stickyImage, defaultStickyImage);
        return;
      }

      mainStage?.classList.remove('is-paper-context');
      [mainImage, firstMobileImage, stickyImage].forEach((image) => {
        if (!image) return;
        image.src = variant.imageSrc;
        image.removeAttribute('srcset');
        image.alt = variant.imageAlt;
        image.classList.add('is-frame-preview');
        image.classList.remove('is-square-lifestyle');
      });
      setActiveProductIndex(0);
      if (mobileGalleryMedia.matches) scrollToProductImage(0);
    };

    const findVariant = (size, frame) => variants.find((variant) => (
      variant.size === size && variant.frame === frame
    ));

    const selectedValue = (inputs) => inputs.find((input) => input.checked)?.value || '';

    const updateOptionAvailability = () => {
      sizeInputs.forEach((input) => {
        input.disabled = !variants.some((variant) => variant.size === input.value && variant.available);
      });

      if (!frameInputs.length) return;
      const size = selectedValue(sizeInputs);
      frameInputs.forEach((input) => {
        const variant = findVariant(size, input.value);
        input.disabled = !variant?.available;
      });

      const framedInput = frameInputs.find((input) => input.dataset.isFramed === 'true');
      if (frameUnavailableMessage) frameUnavailableMessage.hidden = !framedInput?.disabled;
    };

    const updateAddButton = (variant) => {
      if (!primaryAddButton) return;
      primaryAddButton.disabled = !variant.available;
      primaryAddButton.replaceChildren(document.createTextNode(
        variant.available ? `${this.dataset.addLabel} · ` : this.dataset.soldOutLabel
      ));
      primaryAddPrice = null;
      if (variant.available) {
        primaryAddPrice = document.createElement('span');
        primaryAddPrice.dataset.addPrice = '';
        primaryAddPrice.textContent = variant.price;
        primaryAddButton.append(primaryAddPrice);
      }
    };

    const applyVariant = (variant) => {
      if (!variant) return;
      activeVariant = variant;
      if (selectedVariantId) {
        selectedVariantId.value = variant.id;
        selectedVariantId.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (price) price.textContent = variant.price;
      if (primaryAddPrice) primaryAddPrice.textContent = variant.price;
      if (stickyVariant) stickyVariant.textContent = variant.display;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (stickyAddButton) {
        stickyAddButton.disabled = !variant.available;
        this.querySelector('[data-sticky-add-label]').textContent = variant.available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        this.querySelector('[data-sticky-add-amount]').hidden = !variant.available;
      }
      updateAddButton(variant);
      showFramePreview(variant);
      updateGivingAmount();
      this.dispatchEvent(new CustomEvent('sasha:variant', { detail: variant }));
    };

    const resolveSelection = () => {
      const size = selectedValue(sizeInputs);
      let frame = selectedValue(frameInputs);
      let variant = findVariant(size, frame);

      if ((!variant || !variant.available) && frameInputs.length) {
        const unframedInput = frameInputs.find((input) => input.dataset.isFramed !== 'true');
        const unframedVariant = unframedInput ? findVariant(size, unframedInput.value) : null;
        if (unframedInput && unframedVariant?.available) {
          unframedInput.checked = true;
          frame = unframedInput.value;
          variant = unframedVariant;
        }
      }

      updateOptionAvailability();
      applyVariant(variant);
    };

    [...sizeInputs, ...frameInputs].forEach((input) => {
      listen(input, 'change', resolveSelection);
    });

    listen(this.querySelector('[data-sticky-selection]'), 'click', (event) => {
      this.querySelector('sasha-size-picker')?.open(event.currentTarget);
    });

    listen(stickyAddButton, 'click', () => {
      if (!productForm || !primaryAddButton || stickyAddButton.disabled) return;
      productForm.requestSubmit(primaryAddButton);
    });

    if (stickyCart && primaryAddButton) {
      const updateSticky = () => {
        stickyCart.hidden = primaryAddButton.getBoundingClientRect().bottom >= 0;
      };
      const scheduleSticky = () => {
        if (this.stickyFrame) return;
        this.stickyFrame = requestAnimationFrame(() => {
          this.stickyFrame = null;
          updateSticky();
        });
      };
      this.stickyObserver = new IntersectionObserver(updateSticky);
      this.stickyObserver.observe(primaryAddButton);
      listen(window, 'scroll', scheduleSticky, { passive: true });
      listen(window, 'resize', scheduleSticky);
      scheduleSticky();
    }

    resolveSelection();
  }
  disconnectedCallback() {
    this.stickyObserver?.disconnect();
    this.abortController?.abort();
    this.abortController = null;
    cancelAnimationFrame(this.productScrollFrame);
    cancelAnimationFrame(this.initialFrame);
    cancelAnimationFrame(this.stickyFrame);
    this.stickyFrame = null;
    delete this.dataset.initialized;
  }
}

if (!customElements.get('sasha-product')) {
  customElements.define('sasha-product', SashaProduct);
}

  } catch(e) { console.error(e); }
})();
})();
